import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { loggedInAuthGuard } from '@guards/logged-in.guard';
import { mobileRedirectGuard } from '@guards/mobile-redirect.guard';
import { gameResolver } from '@app/resolvers/game.resolver';

const routes: Routes = [
  {
    path: '',
    canMatch: [loggedInAuthGuard],
    canActivate: [gameResolver],
    children: [
      {
        path: 'd',
        loadChildren: () =>
          import('./features/desktop/desktop.routes').then(
            (m) => m.DESKTOP_ROUTES,
          ),
      },
      {
        path: 'm',
        loadChildren: () =>
          import('./features/mobile/mobile.routes').then(
            (m) => m.MOBILE_ROUTES,
          ),
      },
      {
        path: '',
        pathMatch: 'full',
        canActivate: [mobileRedirectGuard],
        loadComponent: () =>
          import('./features/error/error.component').then(
            (m) => m.ErrorComponent,
          ),
      },
    ],
  },
  {
    path: 'error',
    loadComponent: () =>
      import('./features/error/error.component').then((m) => m.ErrorComponent),
  },
  {
    path: 'inactivity',
    loadComponent: () =>
      import('./features/inactivity/inactivity.component').then(
        (m) => m.InactivityComponent,
      ),
  },
  {
    path: '**',
    redirectTo: 'error',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
